/**
 * Badge colour tokens.
 *
 * The template `bg-X-100 text-X-800 dark:bg-X-900 dark:text-X-200` was
 * spelled out about thirty times across five files, which is how variants
 * like a missing dark: pair crept in.
 */
export type BadgeHue =
  | "gray"
  | "red"
  | "orange"
  | "amber"
  | "yellow"
  | "green"
  | "teal"
  | "cyan"
  | "blue"
  | "indigo"
  | "purple"
  | "pink";

/**
 * Tailwind cannot see class names built at runtime, so every hue is written
 * out here in full for the scanner rather than interpolated.
 */
const BADGE: Record<BadgeHue, string> = {
  gray: "bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200",
  red: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200",
  orange:
    "bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200",
  amber: "bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-200",
  yellow:
    "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200",
  green: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
  teal: "bg-teal-100 text-teal-800 dark:bg-teal-900 dark:text-teal-200",
  cyan: "bg-cyan-100 text-cyan-800 dark:bg-cyan-900 dark:text-cyan-200",
  blue: "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200",
  indigo:
    "bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-200",
  purple:
    "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200",
  pink: "bg-pink-100 text-pink-800 dark:bg-pink-900 dark:text-pink-200",
};

export const badge = (hue: BadgeHue): string => BADGE[hue];

/** The pill shape every badge shares, so only the hue varies. */
export const BADGE_PILL =
  "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold";
